import * as React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import PersonIcon from '@mui/icons-material/Person';
import ArrowDropUp from '@mui/icons-material/ArrowDropUp';
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
//import logo from './logo.png'
import logo from './images/logo_triumph.png'

// const pages = ['Replenishment', 'Pricing', 'Blog'];
const settings = ['Dashboard', 'Logout'];

function ResponsiveAppBar() {
  const navigate = useNavigate();
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
	const [anchorElNavSub, setAnchorElNavSub] = React.useState(null);
  const [showMenu, setShowMenu] = React.useState(true);
  const user = JSON.parse(window.localStorage.getItem('user')||"{}");
  const functions = JSON.parse(user.functions||"[]");
  const groupedItems = functions.reduce((acc, item) => {
    const { Group } = item;
    if (!acc[Group]) {
      acc[Group] = [];
    }
    acc[Group].push(item);
    return acc;
  }, {});

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };
	const handleOpenNavSub = (event) => {
    setAnchorElNavSub(event.currentTarget);
  };

  const handleCloseNavMenu = (page) => {
    setAnchorElNav(null);
		setAnchorElNavSub(null);
    // console.log(page);
    if(typeof page === 'string')
      navigate(page, { replace: true });
  };

  const handleCloseUserMenu = (st) => {
    setAnchorElUser(null);
    if(st == "Dashboard")
      navigate("home", { replace: true });
    else if(st == "Logout"){
      window.localStorage.clear();
      navigate("login", { replace: true });
    }
  };

  const toggleAppBar = () => {
    setShowMenu(!showMenu);
  };

  return (
    <div>
      <IconButton
        size="small"
        onClick={toggleAppBar}
        color="inherit"
        style={{position: 'fixed', left: 0, top: -10, zIndex: 1}}
        title={showMenu ? "show menu bar" : "hide menu bar"}
      >
        {showMenu ? <ArrowDropUp style={{color: 'orange'}} /> : <ArrowDropDown style={{color: 'red'}} />}
      </IconButton>
    <AppBar position="static" style={{display: showMenu ? 'block' : 'none'}}>
      <Container maxWidth="xl">
        <Toolbar disableGutters variant='dense' sx={{ minHeight: 50, height: 50 }}>
          <Box component="img" src={logo} onClick={()=>navigate('home')}
            sx={{ height: 40, width: 100, display: { xs: 'none', md: 'flex' }, mr: 1 }}/>
          {/* <Typography
            variant="h6"
            noWrap
            component="a"
            onClick={()=>navigate('home')} //href='home'
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            TRIUMPH
          </Typography> */}
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{ display: { xs: 'block', md: 'none' } }}
            >
              {
                Object.entries(groupedItems).map(([category, items]) => (
                  <MenuItem id='iothers' sx={{padding: 0, margin: 0, width: '100%'}} key={category}>
                    <Typography sx={{ width: '100%', padding: '6px 16px' }} onClick={handleOpenNavSub} id={category}>{category}</Typography>
                    <Menu open={anchorElNavSub && anchorElNavSub.id == category} anchorEl={anchorElNavSub}  id={`m${category}`}
                    onClose={handleCloseNavMenu} keepMounted>
                      {
                        items.map(i=>(
                          <MenuItem onClick={()=>handleCloseNavMenu(i.Form)} key={i.Form}><Typography sx={{ textAlign: 'center' }}>{i.Name}</Typography></MenuItem>
                        ))
                      }
                    </Menu>
                  </MenuItem>
                ))
              }
            </Menu>
          </Box>

          <Box component="img" src={logo} onClick={()=>navigate('home')}
            sx={{ height: 40, width: 100, display: { xs: 'flex', md: 'none' }, mr: 1 }} />
          <Typography
            variant="h5"
            noWrap
            component="a"
            onClick={()=>navigate('home')}
            sx={{
              mr: 2,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          ></Typography>

          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {
              Object.entries(groupedItems).map(([category, items]) => (
                <MenuItem id='iothers' sx={{padding: 0, margin: 0}} key={category}>
                  <Typography sx={{ textAlign: 'center', padding: '14px 8px' }} onClick={handleOpenNavSub} id={category}>{category}</Typography>
                  <Menu open={(anchorElNavSub && anchorElNavSub.id == category)?true:false} anchorEl={anchorElNavSub}  id={`m${category}`}
							      onClose={handleCloseNavMenu} keepMounted>
                    {
                      items.map(i=>(
                        <MenuItem onClick={()=>handleCloseNavMenu(i.Form)} key={i.Form}><Typography sx={{ textAlign: 'center' }}>{i.Name}</Typography></MenuItem>
                      ))
                    }
                  </Menu>
                </MenuItem>
              ))
            }
          </Box>
          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar alt="Remy Sharp" sx={{ p: 0, width: 33, height: 33 }}><PersonIcon style={{color: '#2196f3'}}/></Avatar>
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: '35px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting) => (
                <MenuItem key={setting} onClick={()=>handleCloseUserMenu(setting)}>
                  <Typography sx={{ textAlign: 'center' }}>{setting}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
    </div>
  );
}
export default ResponsiveAppBar;